import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { Checkbox } from '@wartek-id/checkbox-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Button } from '@wartek-id/button-v1'

import TugasPokokItem from './TugasPokokItem'
import { Card, CardBody } from 'app/KinerjaShared/components/Card'
import { Header } from 'app/KinerjaShared/components/Header'
import { FooterActionV2 } from 'app/KinerjaPSPegawaiPage/components/FooterActionV2'
import {
  TUGAS_POKOK_ITEMS,
  TUGAS_POKOK_TIPS,
} from 'app/KinerjaPSPegawaiPage/constants/tugasPokok'
import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { useAPISubmitTugasPokok } from 'api/kinerja/pengawas-sekolah/tugasPokok'
import { usePerencanaanPS } from 'app/KinerjaPSPegawaiPage/hooks/usePerencanaan'

const TugasPokokPage = () => {
  const router = useRouter()

  const {
    perencanaan,
    apiStatus: getPerencanaanAPIState,
    isPerencanaanV2,
  } = usePerencanaanPS()

  const {
    mutateAsync,
    isLoading: isSubmitLoading,
    isSuccess: isSubmitSuccess,
  } = useAPISubmitTugasPokok()

  const hasAccepted =
    getPerencanaanAPIState === 'success' &&
    perencanaan?.tugasPokokStatus !== 'MULAI_PERENCANAAN'
  const isLoadingData = getPerencanaanAPIState === 'loading'
  const [isChecked, setIsChecked] = useState(hasAccepted)

  const handleSaveClick = async () => {
    await mutateAsync()
    router.push(`${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/beranda`)
  }
  const handleBackClick = () => {
    router.back()
  }

  useEffect(() => {
    if (!isPerencanaanV2) {
      router.replace(
        `${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/beranda`
      )
    }
  }, [isPerencanaanV2, router])

  return (
    <div className="pb-20">
      <Header title="Tugas Pokok" className="mb-9 print:hidden" />

      <div className="grid grid-cols-10 gap-x-3">
        <div className="col-span-3">
          <Card className="sticky bg-white border rounded-md border-subdued top-24">
            <CardBody className="p-6 space-y-6">
              <Text variant="heading-sm" className="flex-1">
                Tips tugas pokok
              </Text>
              <div className="space-y-4 text-left">
                {TUGAS_POKOK_TIPS.tips.map((tip, index) => (
                  <div key={index} className="flex space-x-3">
                    <Icon>check_circle_outlined</Icon>
                    <div className="space-y-1">
                      <Text>{tip}</Text>
                    </div>
                  </div>
                ))}
              </div>

              <Button
                color="white"
                onClick={() => {
                  if (TUGAS_POKOK_TIPS.url) {
                    window.open(TUGAS_POKOK_TIPS.url, '_blank')
                  }
                }}
                size="md"
                variant="ghost"
                fullWidth
                className="!text-blue-70 !outline-none space-x-1"
              >
                <Icon color="informational">help</Icon>
                <span>Tentang Tugas Pokok</span>
              </Button>
            </CardBody>
          </Card>
        </div>

        <div className="col-span-7">
          <Card className="sticky bg-white border rounded-md border-subdued top-24">
            <CardBody className="p-6 space-y-2 pb-0">
              <Text variant="heading-lg">Tugas Pokok Pengawas Sekolah</Text>
              <Text variant="body" color="subdued">
                Pengawas Sekolah melakukan tugas keseharian dan tugas tambahan
                di satuan pendidikan, tidak perlu mengunggah bukti dukung apapun
              </Text>
            </CardBody>
            <CardBody className="p-6 space-y-6">
              {TUGAS_POKOK_ITEMS.map(({ title, subItems }, index) => (
                <TugasPokokItem key={index} title={title} subItems={subItems} />
              ))}
            </CardBody>
            <CardBody className="p-6 pt-0">
              <div className="bg-surface-selected-default p-4 pt-2 rounded-xl">
                <Checkbox
                  onChange={(e) => setIsChecked(e?.target?.checked || false)}
                  checked={isChecked || hasAccepted}
                  controlled
                  disabled={
                    hasAccepted ||
                    isSubmitLoading ||
                    isSubmitSuccess ||
                    isLoadingData
                  }
                >
                  <Text variant="body-sm-bold">
                    Saya sudah memahami Tugas Pokok yang harus dilaksanakan
                    Pengawas Sekolah
                  </Text>
                </Checkbox>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      <FooterActionV2
        hasBackButton
        isNextDisabled={
          hasAccepted ||
          isSubmitLoading ||
          !isChecked ||
          isSubmitSuccess ||
          isLoadingData
        }
        nextLabel={isSubmitLoading ? 'Menyimpan..' : 'Simpan'}
        onBack={handleBackClick}
        onNext={handleSaveClick}
      />
    </div>
  )
}

export default TugasPokokPage
